module.exports = {
  fullLang: '中文',
  shortLang: '中文',

  'blog.title': '技术博客',
  'blog.back': '返回技术博客',
  'blog.relatedArticlesHeader': '相关文章',
  'blog.readMore': '立即阅读',
  'blog.postsTagged': '文章标签',
  'blog.allTags': '所有标签',
  'blog.hideTags': '隐藏标签',
  'blog.messageOne': '了解Ouster的最新资讯',
  'blog.messageTwo': '订阅邮件，获得我们所有最新的技术博客!',
  'blog.messageThree': '立即订阅!',
  'blog.defaultAuthor': '团队 Ouster',
  'blog.url': '/zh-cn/company/contact/newsletter/',
  'blog.homeUrl': '/zh-cn/blog/',
  'blog.latestBlogPost': '最新博文',

  'nav.support': '获取演示',
  'nav.getADemo': '支持',

  'cta.download': '下载',
  'cta.readMore': '阅读更多',
  'cta.mostRecent': '最近的',
  'cta.compare': '添加传感器',

  'downloads.title': '下载',
  'downloads.seoTitle': 'Ouster下载中心｜Ouster',
  'downloads.ogDescription':
    '下载激光雷达参数表、使用手册、固件、可视化工具及其他相关文件。',
  'downloads.hardwareVersion': '硬件版本',
  'downloads.firmwareVersion': '固件版本',

  'form.email': '电子邮件',

  'sortable.website': '访问官网',

  'product.pricing': '批量定价',

  'productComparison.select': '最多可选择5个产品进行对比',
  'productComparison.selectShort': '选择激光雷达型号',
  'productComparison.selected': '已选',
  'productComparison.cancel': '取消',
  'productComparison.compare': '对比',
  'productComparison.sensorsSelected': '已选激光雷达',

  'distributor.logo': '徽标',
  'distributor.regions': '服务区域',
  'distributor.services': '服务',

  'careers.apply': '申请此职位',
  'careers.description': `Ouster 原明 {job} 何 {location}, 先之造站微!`,
  'careers.title': `{job} 的工作机会 {location} | Ouster`,

  'firmware.download': '下载',
  'firmware.copy': '复制',
  'firmware.copied': '已复制',
  'firmware.note': '注意',
  'firmware.updates': '更新',
  'firmware.sha256Hash': 'SHA256 HASH',
}
